/**
 * 数科-臻有钱首页-弹窗 - 通过广告投放系统接入 https://fat-admaster.hellobike.cn/#/ssp/operation-mng
 * 广告位信息
 * 名称:数科-臻有钱首页-弹窗
 * uuid:4eaeb691d24c4e4a9b4289eb3b06192e
 */
import { Vue, Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import type { TempAmountStatus } from '@/api/tempAmount/types';
import { dialogHelper } from '@/shared/utils/dialogHelper';
import { changeTabbarMaskStatus } from '@/api/native/container';
import { getTabIdByPath } from '@/shared/utils/getTabIdByPath/getTabIdByPath';
import platform from '@/shared/utils/platform';
import AdvCommonContainer from '../adv-common-container';

const TempAmountStore = namespace('tempAmount');
const HomeStore = namespace('home');

/** 组件上一次渲染的id */
let componentLastRenderId = 0;

interface ApplyingCofigType {
  defaultImg: string;
  data: ApplyWordType;
  styleUrl: string;
}

interface ApplyWordType {
  impId: string;
  availableAmount : string;
}

 @Component
export default class AdvHomePopup extends Vue {
  @TempAmountStore.Getter isHasIssuedTempAmount!: boolean;

  @TempAmountStore.State tempAmountStatus!: TempAmountStatus;

  @HomeStore.State homeLoadAdvRefreshSignal!: number;

  private isTempPopup :null | boolean = null;

  private get tqParams() {
    return {
      scene: this.tempAmountStatus?.scene,
    };
  }

  /** 广告位渲染唯一标识，当主动改动homeLoadAdvRefreshSignal，可以触发广告刷新 */
  private get renderId() {
    return Math.max(this.homeLoadAdvRefreshSignal, componentLastRenderId);
  }

  /** 广告位展示时，回调处理 */
  private onLoadHandler(data: {creative: Dictionary[]}) {
    componentLastRenderId = this.renderId;
    /** 已展示了弹窗，同步状态到弹窗管理 */
    dialogHelper.applyOpenDialog(true);

    if (data && data.creative && data.creative.length) {
      const { segment } = data.creative[0] || [];
      if (segment) {
        const { availableAmount = '' } = (segment as ApplyingCofigType).data || {};
        if (availableAmount) {
          this.isTempPopup = true;
          this.$ubtModuleExposeNew('finance_loan_temporaryLimit', this.tqParams);
        }
      }
    }
  }

  private onCancelHandler() {
    /** 已关闭弹窗，同步状态到弹窗管理 */
    dialogHelper.closeDialogNotify();

    if (this.isTempPopup) {
      this.$ubtPageButtonNew('finance_loan_temporaryLimit_close', this.tqParams);
    }
  }

  private onConfirmHandler() {
    /** 已关闭弹窗，同步状态到弹窗管理 */
    dialogHelper.closeDialogNotify();

    if (this.isTempPopup) {
      this.$ubtPageButtonNew('finance_loan_temporaryLimit_withdraw', this.tqParams);
    }
  }

  private beforeDestroy() {
    /** 离开首页-隐藏广告位弹窗的：容器化TabBar遮罩 */
    changeTabbarMaskStatus({
      show: false,
      duration: 100,
      tabId: getTabIdByPath(),
    });
  }

  private render() {
    return (
      /** 微信小程序环境，不展示广告位 */
      platform.isWechatMini
        ? null
        : <AdvCommonContainer
          key={this.renderId}
          advMasterId="4eaeb691d24c4e4a9b4289eb3b06192e"
          customVisibility="true"
          onLoad={this.onLoadHandler.bind(this)}
          onCancel={() => this.onCancelHandler()}
          onConfirm={() => this.onConfirmHandler()}
        />
    );
  }
}
